module.exports = __webpack_public_path__ + "img/progress-success.bd01c5a6.svg";